/**
 *  @class
 *  @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.links = this.querySelectorAll('.social:not(.clipboard):not(.whatsapp):not(.instagram-share)');
      this.instagramLink = this.querySelector('.instagram-share');
      this.clipboard = this.querySelector('.social.clipboard');

      this.clipboard?.addEventListener('click', this.onClipboardClick.bind(this));
      this.instagramLink?.addEventListener('click', this.onInstagramShareClick.bind(this));
      this.setupEventListeners();
    }

    getSharePayload() {
      const shareUrl = this.dataset.shareUrl || window.location.href;
      const shareTitle = this.dataset.shareTitle || document.title;
      const shareText = `${shareTitle} ${shareUrl}`;

      return { shareUrl, shareTitle, shareText };
    }

    onClipboardClick(event) {
      event.preventDefault();
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.clipboard.classList.add('clipboard-success');
        setTimeout(() => {
          this.clipboard.classList.remove('clipboard-success');
        }, 1800);
      });
    }

    onInstagramShareClick(event) {
      event.preventDefault();

      const { shareText } = this.getSharePayload();
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

      if (isMobile) {
        window.location.href = `instagram://sharesheet?text=${encodeURIComponent(shareText)}`;
        return;
      }

      this.openShareWindow(this.instagramLink.getAttribute('href'), 640, 440);
    }

    openShareWindow(href, width, height) {
      const left = (screen.width / 2) - (width / 2);
      const top = (screen.height / 2) - (height / 2) - 100;

      window.open(
        href,
        'social-share',
        `left=${left},top=${top},width=${width},height=${height},toolbar=0,location=0,status=0,scrollbars=1`
      );
    }

    setupEventListeners() {
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const href = link.getAttribute('href');
          if (!href || href === '#') {
            return;
          }

          let width = 640;
          let height = 440;

          if (link.classList.contains('tiktok')) {
            width = 720;
            height = 560;
          } else if (link.classList.contains('youtube')) {
            width = 960;
            height = 720;
          }

          this.openShareWindow(href, width, height);
          event.preventDefault();
        });
      });
    }
  }
  customElements.define('social-share', SocialShare);
}
